export default function AboutSection() {
  const comparisons = [
    { aspect: 'Finding Products', traditional: 'Slow & Manual', kakobuy: 'Organized Database' },
    { aspect: 'Product Comparison', traditional: 'Difficult', kakobuy: 'Easy & Visual' },
    { aspect: 'Category Browsing', traditional: 'Limited', kakobuy: 'Structured System' },
    { aspect: 'Saving Products', traditional: 'Manual Bookmarks', kakobuy: 'Spreadsheet Ready' },
  ];

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
              What Is Kakobuy Spreadsheet?
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5">
              Kakobuy Spreadsheet is a structured product discovery database that helps shoppers find, compare, and organize verified products before purchasing. Built by experienced shopping enthusiasts, it transforms the chaotic browsing experience into an organized, spreadsheet-driven system that saves time and helps you make better buying decisions.
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
              Whether you are searching for the latest sneakers, trending streetwear, or timeless accessories, the Kakobuy Spreadsheet organizes everything into clean, filterable categories so you can instantly find exactly what you need.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent-500 text-background-50 text-sm font-semibold hover:bg-accent-600 transition-all whitespace-nowrap"
            >
              Explore Full Sheet
              <i className="ri-arrow-right-line"></i>
            </a>
            <div className="flex items-center gap-10 mt-8">
              <div>
                <span className="text-3xl md:text-4xl font-heading font-bold text-foreground-900">14K+</span>
                <p className="text-xs text-foreground-500 mt-1">Verified Products</p>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div>
                <span className="text-3xl md:text-4xl font-heading font-bold text-foreground-900">Daily</span>
                <p className="text-xs text-foreground-500 mt-1">Updates</p>
              </div>
            </div>
          </div>
          <div className="relative">
            <div className="rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20of%20organized%20fashion%20items%20on%20cream%20background%2C%20neatly%20arranged%20clothing%20and%20accessories%20in%20grid%20layout%2C%20soft%20natural%20lighting%2C%20editorial%20catalog%20style%2C%20warm%20neutral%20tones%2C%20high%20end%20aesthetic%2C%20clean%20composition%2C%20professional%20product%20display%2C%208k%20detail&width=800&height=1000&seq=about-kakobuy-image-01&orientation=portrait"
                alt="Kakobuy Spreadsheet organized product database"
                title="Kakobuy Spreadsheet - Organized Product Categories"
                className="w-full h-auto object-cover"
              />
            </div>
            <div className="absolute top-4 left-4 bg-background-50 rounded-full px-4 py-2 text-xs font-semibold text-foreground-900">
              Verified Finds
            </div>
          </div>
        </div>

        <div className="mt-16">
          <h3 className="text-xl font-heading font-bold text-foreground-900 mb-8 text-center">
            Why Use Kakobuy Spreadsheet?
          </h3>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-background-300">
                  <th className="text-left py-3 px-4 text-foreground-500 font-medium">Aspect</th>
                  <th className="text-left py-3 px-4 text-foreground-500 font-medium">Traditional Searching</th>
                  <th className="text-left py-3 px-4 text-foreground-900 font-semibold bg-accent-100/50 rounded-t-lg">Kakobuy Spreadsheet</th>
                </tr>
              </thead>
              <tbody>
                {comparisons.map((row, i) => (
                  <tr key={i} className="border-b border-background-200/70">
                    <td className="py-3.5 px-4 text-foreground-700 font-medium">{row.aspect}</td>
                    <td className="py-3.5 px-4 text-foreground-500">{row.traditional}</td>
                    <td className="py-3.5 px-4 text-foreground-900 font-medium bg-accent-50/50">
                      <span className="flex items-center gap-1.5">
                        <i className="ri-check-line text-accent-500 text-xs"></i>
                        {row.kakobuy}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}